import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import AdSlot from './AdSlot';
import { adsEnabled, donationUrl, openConsentChoices } from '../monetization';

/* Required wording from Supercell's Fan Content Policy; keep it verbatim. */
export const FAN_CONTENT_NOTICE =
  "This material is unofficial and is not endorsed by Supercell. For more information see Supercell's Fan Content Policy:";
export const FAN_CONTENT_POLICY_URL = 'https://supercell.com/en/fan-content-policy/';

function SiteFooter() {
  const { pathname } = useLocation();
  return (
    <footer className="site-foot">
      <div className="wrap">
        {pathname !== '/privacy' && <AdSlot slot="footer" />}

        {donationUrl && (
          <div className="donate">
            <p>
              StatYoyo is free for everyone. If it helps you, you can chip in toward server costs.
              Donations are entirely optional and don't unlock anything.
            </p>
            <a className="donate-btn" href={donationUrl} target="_blank" rel="noopener noreferrer">
              <span aria-hidden="true">♥</span> Donate
            </a>
          </div>
        )}

        <p className="fcp-notice">
          {FAN_CONTENT_NOTICE}{' '}
          <a href={FAN_CONTENT_POLICY_URL} target="_blank" rel="noopener noreferrer">www.supercell.com/fan-content-policy</a>.
        </p>

        <div className="foot-links">
          <Link to="/privacy">Privacy &amp; cookies</Link>
          {adsEnabled && (
            <button
              type="button"
              className="linklike"
              onClick={() => { if (!openConsentChoices()) window.location.assign('/privacy#ads'); }}
            >
              Cookie choices
            </button>
          )}
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
